import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { TESTIMONIALS } from "../content/siteContent";
import { locTestimonial } from "../content/i18n_extra";

export function TestimonialsSection() {
  const { t, lang } = useLang();

  return (
    <section id="deneyimler" className="bg-white py-28 sm:py-36" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="max-w-3xl">
          <div className="text-xs font-heading font-bold tracking-[0.3em] uppercase text-brand mb-4">{t("sec_testimonials_kicker")}</div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-ink text-balance">{t("sec_testimonials_title")}</h2>
          <p className="mt-5 text-lg text-sub leading-relaxed">{t("sec_testimonials_sub")}</p>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((item, i) => {
            const c = locTestimonial(item, i, lang);
            return (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
              className="bg-ice rounded-3xl border border-brand/10 p-7 flex flex-col hover:-translate-y-1 hover:shadow-xl hover:shadow-brand/10 transition-[transform,box-shadow] duration-300"
            >
              <Quote size={22} className="text-brand/40" />
              <blockquote className="mt-4 text-sm text-ink/75 leading-relaxed flex-1">"{c.text}"</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-black/5 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-brand text-white flex items-center justify-center font-heading font-bold text-sm">{item.initials}</span>
                <span className="text-[11px] font-semibold text-sub leading-snug">{c.meta}</span>
              </figcaption>
            </motion.figure>
            );
          })}
        </div>
        <p className="mt-8 text-[11px] text-sub">{t("testimonials_note")}</p>
      </div>
    </section>
  );
}
